import { COUPON_CONSTANTS } from "../constants/couponConstants";

const initialState = {
  coupons: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10
  },
  loading: false,
  error: null
};

const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case COUPON_CONSTANTS.FETCH_COUPONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case COUPON_CONSTANTS.FETCH_COUPONS_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: action.payload.response || action.payload,
        pagination: action.payload.pagination || state.pagination,
        error: null
      };
    case COUPON_CONSTANTS.FETCH_COUPONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default couponReducer;